import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { IApiTokenRequest } from '../../services/ScimConfigurationsService';


export interface ApiTokenResponse extends IResult {
    apiToken: {
        clientName?: string;
        id?: string;
        scope?: string;
        secret?: string;
    };
}


export function createApiTokenRequestConfig(request: IApiTokenRequest): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.26',
    httpMethod: 'POST',
    endpoint: `scimConfigurations/${request.scimConfigId}/apiToken`,
    serverWideRequest: false
  };
}



export function callCreateApiTokenForScimConfiguration(request: IApiTokenRequest): Promise<ApiTokenResponse> {
  return makeJsonRestApiRequest<ApiTokenResponse, ApiTokenResponse>({
    config: createApiTokenRequestConfig(request),
    request: {
      apiToken: {
        clientName: request.clientName,
      }
    },
  });
}